import {
  ReportReason,
  ReportReasonType,
} from "../../../lib/apollo/graphql/generated";
import ActiveStatusIcon from "../../common/components/ActiveStatusIcon";

interface ReportReasonItemProps {
  reportReason: ReportReason;
  onSelect: () => void;
  number: number;
}

const REASON_TYPE: {
  [key in ReportReasonType]: string;
} = {
  CAREGIVER_COMMUNITY: "게시물 신고",
  CAREGIVER_COMMUNITY_REPLY: "게시물 댓글 신고",
  CAREGIVER_INFO_REPLY: "정보글 댓글 신고",
  CAREGIVER: "사용자 차단",
};

export default function ReportReasonItem({
  reportReason,
  number,
  onSelect,
}: ReportReasonItemProps) {
  return (
    <div
      className="flex cursor-pointer flex-col rounded-lg border border-zinc-300 px-3 py-5 hover:bg-zinc-100"
      onClick={onSelect}
    >
      <div className="flex items-center gap-2">
        <p className="text-lg font-bold">
          {number}. {reportReason.reason}
        </p>
        <ActiveStatusIcon isActive={reportReason.active} />
      </div>
      <div>
        <span className="text-sm text-zinc-500">
          {REASON_TYPE[reportReason.type as keyof typeof REASON_TYPE]}
        </span>
      </div>
    </div>
  );
}
